<template>
  <div :class="$style.page">
    <Header :showCenter="false" />

    <div :class="$style.content">
      <div :class="$style.content_left">
        <img
          :class="$style.banner"
          src="@assets/image/login_bg.png"
          alt="banner"
        />
      </div>

      <div :class="$style.content_right">
        <Loading :loading="loading" icon="el-icon-loading" text="登录中...">
          <div :class="$style.form">
            <Row :class="$style.logo">
              <img src="@assets/image/logo.png" alt="logo" />
            </Row>
            <Row>
              <div :class="[$style.desc,tab == 1 ? $style.checked :'']"  @click="tab = 1">密码登录</div>
              <div :class="[$style.desc,tab == 2 ? $style.checked :'']"  @click="tab = 2">短信/邮箱登录</div>
              <router-link to="/register" :class="$style.register_link">
                立即注册
              </router-link>
            </Row>
            <!-- 密码登录 -->
            <template v-if='tab == 1'>
            <Row>
              <el-input
                placeholder="手机号码/邮箱"
                v-model.trim="account"
              >
                <img slot="prefix" src="@assets/image/user.png" alt="people" />
              </el-input>
            </Row>

            <Row>
              <el-input
                placeholder="请输入登录密码"
                v-model.trim="password"
                type="password"
                maxlength="16"
              >
                <img slot="prefix" src="@assets/image/lock.png" alt="lock" />
              </el-input>
            </Row>
            </template>
            <template v-if='tab == 2'>
            <Row>
              <el-input
                placeholder="手机号码/邮箱"
                v-model.trim="account"
              >
                <img slot="prefix" src="@assets/image/user.png" alt="people" />
              </el-input>
            </Row>

             <Row>
              <el-input
                v-model.trim="code"
                placeholder="验证码"
                maxlength="6"
              />
               <el-button
                   class="codeBtn"
                   @click="refreshCode"
                   :disabled="codeDisabled"
                   style="color: #ff5c35; border: 1px solid #ff5c35;margin-left: .2rem !important;"
               >
                 {{ text1 }}
               </el-button>
            </Row>
            </template>


            <Row>
              <Button type="primary" @click="clickLogin">登录</Button>
            </Row>

            <Row :class="$style.form_bottom">
              <el-checkbox v-model="isMemory">记住我</el-checkbox>
              <router-link to="/forget" :class="$style.find_link">
                忘记密码 ?
              </router-link>
            </Row>
          </div>
        </Loading>
      </div>
    </div>

    <Footer />
    <el-dialog width="40%" title="验证码" :visible.sync="verifyshow" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="verifyshow = false">取 消</el-button>
        <el-button type="primary"  @click="getCodeEvent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";

import { getPublicKey } from "@server";
import { validPhone, validEmail, encryptPwd } from "@utils";
import { getLoginCode } from "@server";
import { API_BASE_URL } from '@utils/config';
export default {
  name: "Login",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      account: "", // 账户
      password: "", // 账户密码
      isMemory: false, // 记住我
      loading: false,
      code:'',
      tab:1,//密码登录 2验证码登录
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
  },
  methods: {
    refreshCode() {
      if (!this.account || this.account === '') {
        return this.$message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}/hbsdweb/sms/login/validateCode?mobile=${this.account}`
      }, 0)
    },
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$message.warning("图形验证码不能为空！");
      }
      if (!validPhone(this.account) && !validEmail(this.account)) {
        this.$message.warning("请输入正确的手机号码或邮箱！");
        return;
      }
      getLoginCode(this.account, this.codeValue)
          .then((res) => {
            if (res.code === 200 && res.result) {
              let i = 60;
              this.text1 = `${i--}秒后再获取`;
              this.codeDisabled = true
              this.verifyshow = false
              this.getCodeInterval = setInterval(() => {
                if (i <= 1) {
                  this.text1 = "获取验证码";
                  clearInterval(this.getCodeInterval);
                  this.codeDisabled = false
                  return;
                }
                this.text1 = `${i--}秒后再获取`;
              }, 1000);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
          });
    },
    ...mapActions("login", ["loginAction"]),

    async getPublicKey() {
      //  获取公钥
      if (!this.$storage.getPublicKey()) {
        let res = await getPublicKey();
        if (res.code == 200) {
          this.$storage.setPublicKey(res.data);
        }
      }
    },

    setMemory() {
      let info = this.$storage.getMemoryInfo();
      if (info) {
        this.account = info;
        this.isMemory = true;
      }
    },

    checkLogin() {
      if (!validPhone(this.account) && !validEmail(this.account)) {
        this.$message({
          message: `请输入${this.account ? "正确的" : ""}手机号码或邮箱`,
          type: "warning",
        });
        return false;
      }

      if(this.tab == 1){
        if (this.password.length < 8) {
          this.$message({
            message: `请输入${this.password ? "正确的" : ""}登录密码`,
            type: "warning",
          });
          return false;
        }
      }else{
        if (this.code.length !== 6 ) {
          this.$message({
           message: `请输入${this.code ? "正确的" : ""}验证码`,
           type: "warning",
          });
          return false;
        }
      }


      return true;
    },

    async clickLogin() {
      if (!this.checkLogin()) return;

      this.loading = true;
      let params
      if(this.tab == 1){
        params = {
          type: 0,
          source: 0,
          account: this.account,
          password: encryptPwd(this.password),
        };
      }else{
        params = {
          type: 1,
          source: 0,
          account: this.account,
          msgCode:this.code
        };
      }

      const res = await this.loginAction(params);

      const { code, message } = res;

      if (code == 200) {
        this.$message({ message, type: "success" });

        this.$storage.setMemoryInfo(this.isMemory ? this.account : "");

        setTimeout(() => {
          let path = this.$storage.getBeforeLoginPath();
          this.$storage.setBeforeLoginPath("/");
          this.$router.replace(path || "/"); // 登录成功后默认跳转登录前停留的页面
        }, 1000);
      } else {
        this.$message({ message, type: "error" });
      }
      this.loading = false;
    },
  },
  created() {
    this.getPublicKey();
    this.setMemory();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;

  :global {
    .gl-row {
      margin-bottom: rem(30);
      justify-content: space-between;
    }

    ::v-deep .el-input {
      &.el-input--prefix {
        .el-input__inner {
          padding-left: rem(56);
        }
      }

      .el-input__prefix {
        left: 0;
        width: rem(56);
        @include flex();

        img {
          width: max(rem(16), 12px);
          object-fit: cover;
        }
      }
    }

    .gl-button {
      width: 100%;
      margin: 0;
    }

    ::v-deep .el-checkbox {
      margin-right: rem(60);

      .el-checkbox__label {
        padding-left: rem(15);
      }
    }
  }

  .content {
    flex: 1;
    margin: rem(60) auto;
    padding-top: rem(80);
    display: flex;
    justify-content: center;

    .content_left {
      width: rem(820);
      height: rem(680);
      margin-right: rem(60);

      .banner {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content_right {
      box-sizing: border-box;
      width: rem(490);
      min-width: 245px;
      height: rem(680);
      padding: rem(24) rem(60);
      background: #fff;
      box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.06);
      border: $border-1;
      border-radius: 4px;
    }
  }

  .form {
    height: 100%;

    .logo {
      height: rem(120);
      @include flex();

      img {
        height: rem(54);
        object-fit: cover;
      }
    }

    .desc {
      font-size: max(rem(16), 13px);
      font-weight: bold;
      color: #333;
      cursor: pointer;
      &.checked{
        color: $theme-color;
      }
    }

    .register_link {
      font-size: rem(14);
      color: $theme-color;
      line-height: rem(60);
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    .login_btn {
      width: 100%;
    }

    .form_bottom {
      padding: 0 20px;
    }

    .find_link {
      font-size: 14px;
      color: #999;
      line-height: rem(60);
      text-decoration: none;
      &:hover {
        color: $theme-color;
        text-decoration: underline;
      }
    }
  }
}

</style>
<style>
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
.el-button--primary {
  color: #FFF;
  background-color: #ff5c35;
  border-color: #ff5c35;
}
</style>
